// Registers /service-worker.js in production and keeps the app auto-updating.
//
// Updates are applied while the app is in the FOREGROUND — specifically each
// time it's brought back to the front. This is the only reliable moment on
// iOS, where a backgrounded PWA is frozen and cannot run its own update logic.
// (The service worker file is stamped with a unique build id at build time so
// the browser actually detects each new deploy — see scripts/stamp-sw.js.)

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Activate a waiting build, but only while the app is visible so the
        // reload happens on-screen (and actually runs on iOS).
        const applyIfVisible = () => {
          if (document.visibilityState === 'visible' && registration.waiting) {
            registration.waiting.postMessage('SKIP_WAITING');
          }
        };

        // A newer build may already be waiting from a previous visit.
        if (registration.waiting && navigator.serviceWorker.controller) applyIfVisible();

        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            // `controller` present => this replaces a running version (an update,
            // not the first install), so apply it.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              applyIfVisible();
            }
          };
        };

        // Each time the app comes to the foreground: apply anything already
        // waiting, then check the server for something newer.
        const onForeground = () => {
          if (document.visibilityState !== 'visible') return;
          applyIfVisible();
          registration.update().catch(() => {});
        };
        window.addEventListener('focus', onForeground);
        document.addEventListener('visibilitychange', onForeground);
      })
      .catch((err) => console.error('SW registration failed:', err));

    // Once the freshly-activated SW takes control, reload to run the new build.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
